export default "__VITE_ASSET__57hXaElA__"